import { status } from 'skin/event/status';
import api from 'skin/http';

const prod = (obj, form, story, data, d, action) => {
	const id = obj.row.key
	const config = {
		method: 'delete',
		url: 'api/other/form/goods/del/' + id,
		
	};
	api(config)
		.then(res => {
			const o = {
				type: 'form',
				action: 'reload',
			};
			action(o);
		})
		.catch(console.log);
	return status.ignore;
};

export default prod;
